namespace TR {
    class HolidayDealPromoListing {

        getLabel: Function;

        name: string;
        value: string;
        group: string;
        label: string;
        type: string;
        index: number;

        $overlay;
        $iconOverlay;

        constructor (
            $element: any,
            $scope: ng.IScope,
            $sce: ng.ISCEService,
            private $location: any,
            private broker: any,
            private resourceService: Core.ResourceService
        ) {
            this.$overlay = $element.find('.holiday-deal-promo-listing .click-overlay');
            this.$iconOverlay = $element.find('.holiday-deal-promo-listing .icon-overlay');

            this.getLabel = label => {
                const res = resourceService.get(label);
                $sce.trustAsHtml(label);
                return res;
            };

            this.broker.subscribe(`PROMO_${this.type}_${this.index}`, 'PROMO_OVERLAY', ({ data }) => {
                if (this.group !== data.group) { return; }

                if (this.name !== data.name) {
                    this.$location.search(this.name, null);
                }

                if (this.value !== data.value) {
                    this._toggleOverlay(false);
                }
            });

            $scope.$watch('hpl.value', v => {
                if (!v) { return; }
                const params = this.$location.search();
                this._toggleOverlay(params[this.name] === v);
            });

            $scope.$on('$destroy', () => {
                this.broker.unsubscribe('holidayDealsPromoController', `PROMO_${this.type}_${this.index}`);
            });
        }

        select() {
            this.broker.publish('PROMO_OVERLAY', {
                name: this.name,
                group: this.group,
                value: this.value,
                type: this.type || this.getLabel(this.label)
            });
            const params = this.$location.search();
            const isAlreadySelected = params[this.name] === this.value;
            if (isAlreadySelected) { return; }
            this.$location.search(this.name, this.value);
            this._toggleOverlay(true);
        }

        private _toggleOverlay(show) {
            if (show) {
                this.$overlay.fadeIn(200);
                this.$iconOverlay.fadeIn(200);
                return;
            }
            this.$overlay.fadeOut(200);
            this.$iconOverlay.fadeOut(200);
        }
    }

    angular
        .module('TR')
        .directive('holidayDealPromoListing', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: 'partials/home/directivetemplate?type=HolidayDealPromoListing',
                bindToController: {
                    label: '@',
                    img: '@',
                    name: '@',
                    value: '=',
                    group: '@',
                    type: '@',
                    index: '@'
                },
                controller: HolidayDealPromoListing,
                controllerAs: 'hpl'
            };
        });

}
